import React from 'react';
import login from "../consumers/login";

const exit = ({auth})=>{
    if (auth.currentUser) {
        return <li><a href="#" onClick={()=>auth.signOut()}>Logout</a></li>
    }
    return "";
};
const Logout = login(exit);
export default Logout;


// WEBPACK FOOTER //
// ./src/subscribers/Logout.js